/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../plugins/vant-demand-import/installComponents.js"
import VanOverlay from 'vant/es/overlay'
import 'vant/es/overlay/style/less'


import { render, staticRenderFns } from "./launching.vue.js?vue&type=template&id=5d9e5aee!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./launching.vue?vue&type=template&id=5d9e5aee"
import script from "./launching.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./launching.vue?vue&type=script&lang=ts&setup=true"
export * from "./launching.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./launching.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./launching.vue.postcss?vue&type=style&index=0&id=5d9e5aee&prod&lang=postcss&module=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./launching.vue?vue&type=style&index=0&id=5d9e5aee&prod&lang=postcss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanOverlay})
